import component from './ct-select'

const com = {
  install (Vue) {
    Vue.component('CTSelect', component)
  }
}
export default com
